import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { fetchGetNews } from "./asyncActions";
import { INews, INewsState } from "./types";

const initialState: INewsState = {
  isLoading: false,
  news: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(fetchGetNews.pending, (state) => {
      state.isLoading = true;
    })
    builder.addCase(fetchGetNews.fulfilled, (state, action: PayloadAction<INews[]>) => {
      state.news = action.payload
      state.isLoading = false;
    })
    builder.addCase(fetchGetNews.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export default cartSlice.reducer;
